<template>
  <div class="login-view">
    <el-form
      :model="loginForm"
      status-icon
      :rules="rules"
      ref="loginForm"
      label-width="100px"
      class="web-ruleForm"
      @keyup.enter.native="submitForm('loginForm')"
    >
      <div class="login-brand">Welcome to login</div>
      <el-form-item label="Username" prop="userName">
        <el-input
          type="userName"
          v-model="loginForm.userName"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="Passwords" prop="password">
        <el-input
          type="password"
          v-model="loginForm.password"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('loginForm')"
          >sign in</el-button
        >
        <el-button @click="resetForm('loginForm')">clear</el-button>
      </el-form-item>
      <!-- <div class="register">
        <router-link to="/register">没有账号,前往注册</router-link>
      </div> -->
    </el-form>
  </div>
</template>

<script>
export default {
  name: "login",
  data() {
    var checkUsername = (rule, value, callback) => {
      console.log("checkUsername");
      if (!value) {
        return callback(new Error("Please enter your username"));
      }
      callback();
    };
    var checkPassword = (rule, value, callback) => {
      console.log("checkPassword");
      if (value === "") {
        callback(new Error("Please enter your password"));
      }
      callback();
    };
    return {
      loginForm: {
        userName: "",
        password: "",
      },
      rules: {
        userName: [
          {
            validator: checkUsername,
            trigger: "blur",
          },
        ],
        password: [
          {
            validator: checkPassword,
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http({
            url: "/login",
            method: "post",
            data: this.loginForm,
          }).then((data) => {
            // 保存密码到cookie(不安全)
            // this.setCookie('username',this.loginForm.userName);
            // this.setCookie('password',this.loginForm.password);
            // 保存token
            sessionStorage.setItem("accessToken", data.accessToken);
            sessionStorage.setItem("refreshToken", data.refreshToken);
            this.$message.success("ogin Successful");
            this.$router.push("/home/chat");
          });
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 获取cookie、
    getCookie(name) {
      let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      let arr = document.cookie.match(reg);
      if (arr) {
        return unescape(arr[2]);
      }
      return "";
    },
    // 设置cookie,增加到vue实例方便全局调用
    setCookie(name, value, expiredays) {
      var exdate = new Date();
      exdate.setDate(exdate.getDate() + expiredays);
      document.cookie =
        name +
        "=" +
        escape(value) +
        (expiredays == null ? "" : ";expires=" + exdate.toGMTString());
    },
    // 删除cookie
    delCookie(name) {
      var exp = new Date();
      exp.setTime(exp.getTime() - 1);
      var cval = this.getCookie(name);
      if (cval != null) {
        document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
      }
    },
  },
  mounted() {
    this.loginForm.userName = this.getCookie("username");
    // cookie存密码并不安全，暂时是为了方便
    this.loginForm.password = this.getCookie("password");
  },
};
</script>

<style scoped lang="scss">
.login-view {
  position: relative;
  display: flex;
  justify-content: space-around;
  width: 100%;
  height: 100%;
  background: linear-gradient(#65807a, #182e3c);
  background-size: cover;

  .web-ruleForm {
    height: 340px;
    padding: 20px;
    margin-top: 150px;
    background: rgba(255, 255, 255, 0.75);
    box-shadow: 0px 0px 1px #ccc;
    width: 450px;
    border-radius: 5px;
    overflow: hidden;

    .login-brand {
      line-height: 50px;
      margin: 30px 0 40px 0;
      font-size: 22px;
      font-weight: 600;
      letter-spacing: 2px;
      text-transform: uppercase;
      text-align: center;
    }

    .register {
      display: flex;
      flex-direction: row-reverse;
      line-height: 40px;
      text-align: left;
      padding-left: 20px;
    }
  }
}
</style>
